import { OrdersListTableRow } from './orders-list-table-row'
import type { ReactNode } from 'react'

import type {
    SalesOrder,
    SalesOrderListTotals,
} from '@/lib/api/sales-order-api'
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/components/ui/table'
import { formatVnd } from '@/lib/format'
import { m } from '@/lib/paraglide/messages'

const COLUMNS = 12
// Ô "Tổng N đơn" trải qua các cột trước "Tổng tiền".
const LEAD_COLUMNS = 4

interface Props {
    orders: SalesOrder[]
    isLoading: boolean
    emptyState: ReactNode
    /** Tổng của CẢ tập đơn khớp bộ lọc (meta.totals), không chỉ trang này. */
    totals?: SalesOrderListTotals
    totalCount?: number
    onTrackOpen: (order: SalesOrder, index: number) => void
    /** The pending-invoice list is showing: rows carry an age and open with its source. */
    pendingList?: boolean
}

/** Bảng đơn desktop; dòng tổng ngay dưới tiêu đề như KiotViet. */
export function OrdersListTable({
    orders,
    isLoading,
    emptyState,
    totals,
    totalCount,
    onTrackOpen,
    pendingList,
}: Props) {
    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>{m.order_code()}</TableHead>
                    <TableHead>{m.order_internal_code()}</TableHead>
                    <TableHead>{m.order_customer()}</TableHead>
                    <TableHead>{m.order_channel()}</TableHead>
                    <TableHead>{m.order_total()}</TableHead>
                    <TableHead>{m.order_paid_col()}</TableHead>
                    <TableHead>{m.order_payment()}</TableHead>
                    <TableHead>{m.order_status()}</TableHead>
                    <TableHead>{m.order_lot_debt_col()}</TableHead>
                    <TableHead>{m.einvoice_filter_label()}</TableHead>
                    <TableHead>{m.order_sla_label()}</TableHead>
                    <TableHead>{m.order_created_date()}</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {isLoading ? (
                    <TableRow>
                        <TableCell
                            colSpan={COLUMNS}
                            className="text-center text-muted-foreground py-8"
                        >
                            {m.common_loading()}
                        </TableCell>
                    </TableRow>
                ) : orders.length === 0 ? (
                    <TableRow>
                        <TableCell colSpan={COLUMNS}>{emptyState}</TableCell>
                    </TableRow>
                ) : (
                    <>
                        {totals ? (
                            <TableRow className="bg-muted/50 font-semibold hover:bg-muted/50">
                                <TableCell colSpan={LEAD_COLUMNS}>
                                    {m.order_totals_row({
                                        count: String(
                                            totalCount ?? orders.length,
                                        ),
                                    })}
                                </TableCell>
                                <TableCell className="tabular-nums">
                                    {formatVnd(Math.round(totals.total_amount))}
                                </TableCell>
                                <TableCell className="tabular-nums">
                                    {formatVnd(Math.round(totals.paid_amount))}
                                </TableCell>
                                <TableCell
                                    colSpan={COLUMNS - LEAD_COLUMNS - 2}
                                />
                            </TableRow>
                        ) : null}
                        {orders.map((order, index) => (
                            <OrdersListTableRow
                                key={order.id}
                                order={order}
                                pendingList={pendingList}
                                onTrackOpen={() => onTrackOpen(order, index)}
                            />
                        ))}
                    </>
                )}
            </TableBody>
        </Table>
    )
}
